/**
 * Season Regional & Metadata Constants
 * Comprehensive list of Countries, Phone Codes, Time Zones, Languages, and Language-mapped Bible Versions.
 */

// ─── 1. Comprehensive Countries & Dial Codes ──────────────────────────────────
export const ALL_COUNTRIES_DATA = [
  { name: 'Afghanistan', code: 'AF', dialCode: '+93' },
  { name: 'Albania', code: 'AL', dialCode: '+355' },
  { name: 'Algeria', code: 'DZ', dialCode: '+213' },
  { name: 'Andorra', code: 'AD', dialCode: '+376' },
  { name: 'Angola', code: 'AO', dialCode: '+244' },
  { name: 'Antigua and Barbuda', code: 'AG', dialCode: '+1-268' },
  { name: 'Argentina', code: 'AR', dialCode: '+54' },
  { name: 'Armenia', code: 'AM', dialCode: '+374' },
  { name: 'Australia', code: 'AU', dialCode: '+61' },
  { name: 'Austria', code: 'AT', dialCode: '+43' },
  { name: 'Azerbaijan', code: 'AZ', dialCode: '+994' },
  { name: 'Bahamas', code: 'BS', dialCode: '+1-242' },
  { name: 'Bahrain', code: 'BH', dialCode: '+973' },
  { name: 'Bangladesh', code: 'BD', dialCode: '+880' },
  { name: 'Barbados', code: 'BB', dialCode: '+1-246' },
  { name: 'Belarus', code: 'BY', dialCode: '+375' },
  { name: 'Belgium', code: 'BE', dialCode: '+32' },
  { name: 'Belize', code: 'BZ', dialCode: '+501' },
  { name: 'Benin', code: 'BJ', dialCode: '+229' },
  { name: 'Bhutan', code: 'BT', dialCode: '+975' },
  { name: 'Bolivia', code: 'BO', dialCode: '+591' },
  { name: 'Bosnia and Herzegovina', code: 'BA', dialCode: '+387' },
  { name: 'Botswana', code: 'BW', dialCode: '+267' },
  { name: 'Brazil', code: 'BR', dialCode: '+55' },
  { name: 'Brunei', code: 'BN', dialCode: '+673' },
  { name: 'Bulgaria', code: 'BG', dialCode: '+359' },
  { name: 'Burkina Faso', code: 'BF', dialCode: '+226' },
  { name: 'Burundi', code: 'BI', dialCode: '+257' },
  { name: 'Cambodia', code: 'KH', dialCode: '+855' },
  { name: 'Cameroon', code: 'CM', dialCode: '+237' },
  { name: 'Canada', code: 'CA', dialCode: '+1' },
  { name: 'Cape Verde', code: 'CV', dialCode: '+238' },
  { name: 'Central African Republic', code: 'CF', dialCode: '+236' },
  { name: 'Chad', code: 'TD', dialCode: '+235' },
  { name: 'Chile', code: 'CL', dialCode: '+56' },
  { name: 'China', code: 'CN', dialCode: '+86' },
  { name: 'Colombia', code: 'CO', dialCode: '+57' },
  { name: 'Comoros', code: 'KM', dialCode: '+269' },
  { name: 'Congo (Brazzaville)', code: 'CG', dialCode: '+242' },
  { name: 'Congo (DRC)', code: 'CD', dialCode: '+243' },
  { name: 'Costa Rica', code: 'CR', dialCode: '+506' },
  { name: 'Croatia', code: 'HR', dialCode: '+385' },
  { name: 'Cuba', code: 'CU', dialCode: '+53' },
  { name: 'Cyprus', code: 'CY', dialCode: '+357' },
  { name: 'Czech Republic', code: 'CZ', dialCode: '+420' },
  { name: 'Denmark', code: 'DK', dialCode: '+45' },
  { name: 'Djibouti', code: 'DJ', dialCode: '+253' },
  { name: 'Dominica', code: 'DM', dialCode: '+1-767' },
  { name: 'Dominican Republic', code: 'DO', dialCode: '+1-809' },
  { name: 'East Timor', code: 'TL', dialCode: '+670' },
  { name: 'Ecuador', code: 'EC', dialCode: '+593' },
  { name: 'Egypt', code: 'EG', dialCode: '+20' },
  { name: 'El Salvador', code: 'SV', dialCode: '+503' },
  { name: 'Equatorial Guinea', code: 'GQ', dialCode: '+240' },
  { name: 'Eritrea', code: 'ER', dialCode: '+291' },
  { name: 'Estonia', code: 'EE', dialCode: '+372' },
  { name: 'Eswatini', code: 'SZ', dialCode: '+268' },
  { name: 'Ethiopia', code: 'ET', dialCode: '+251' },
  { name: 'Fiji', code: 'FJ', dialCode: '+679' },
  { name: 'Finland', code: 'FI', dialCode: '+358' },
  { name: 'France', code: 'FR', dialCode: '+33' },
  { name: 'Gabon', code: 'GA', dialCode: '+241' },
  { name: 'Gambia', code: 'GM', dialCode: '+220' },
  { name: 'Georgia', code: 'GE', dialCode: '+995' },
  { name: 'Germany', code: 'DE', dialCode: '+49' },
  { name: 'Ghana', code: 'GH', dialCode: '+233' },
  { name: 'Greece', code: 'GR', dialCode: '+30' },
  { name: 'Grenada', code: 'GD', dialCode: '+1-473' },
  { name: 'Guatemala', code: 'GT', dialCode: '+502' },
  { name: 'Guinea', code: 'GN', dialCode: '+224' },
  { name: 'Guinea-Bissau', code: 'GW', dialCode: '+245' },
  { name: 'Guyana', code: 'GY', dialCode: '+592' },
  { name: 'Haiti', code: 'HT', dialCode: '+509' },
  { name: 'Honduras', code: 'HN', dialCode: '+504' },
  { name: 'Hong Kong', code: 'HK', dialCode: '+852' },
  { name: 'Hungary', code: 'HU', dialCode: '+36' },
  { name: 'Iceland', code: 'IS', dialCode: '+354' },
  { name: 'India', code: 'IN', dialCode: '+91' },
  { name: 'Indonesia', code: 'ID', dialCode: '+62' },
  { name: 'Iran', code: 'IR', dialCode: '+98' },
  { name: 'Iraq', code: 'IQ', dialCode: '+964' },
  { name: 'Ireland', code: 'IE', dialCode: '+353' },
  { name: 'Israel', code: 'IL', dialCode: '+972' },
  { name: 'Italy', code: 'IT', dialCode: '+39' },
  { name: 'Ivory Coast', code: 'CI', dialCode: '+225' },
  { name: 'Jamaica', code: 'JM', dialCode: '+1-876' },
  { name: 'Japan', code: 'JP', dialCode: '+81' },
  { name: 'Jordan', code: 'JO', dialCode: '+962' },
  { name: 'Kazakhstan', code: 'KZ', dialCode: '+7' },
  { name: 'Kenya', code: 'KE', dialCode: '+254' },
  { name: 'Kiribati', code: 'KI', dialCode: '+686' },
  { name: 'Kosovo', code: 'XK', dialCode: '+383' },
  { name: 'Kuwait', code: 'KW', dialCode: '+965' },
  { name: 'Kyrgyzstan', code: 'KG', dialCode: '+996' },
  { name: 'Laos', code: 'LA', dialCode: '+856' },
  { name: 'Latvia', code: 'LV', dialCode: '+371' },
  { name: 'Lebanon', code: 'LB', dialCode: '+961' },
  { name: 'Lesotho', code: 'LS', dialCode: '+266' },
  { name: 'Liberia', code: 'LR', dialCode: '+231' },
  { name: 'Libya', code: 'LY', dialCode: '+218' },
  { name: 'Liechtenstein', code: 'LI', dialCode: '+423' },
  { name: 'Lithuania', code: 'LT', dialCode: '+370' },
  { name: 'Luxembourg', code: 'LU', dialCode: '+352' },
  { name: 'Macau', code: 'MO', dialCode: '+853' },
  { name: 'Madagascar', code: 'MG', dialCode: '+261' },
  { name: 'Malawi', code: 'MW', dialCode: '+265' },
  { name: 'Malaysia', code: 'MY', dialCode: '+60' },
  { name: 'Maldives', code: 'MV', dialCode: '+960' },
  { name: 'Mali', code: 'ML', dialCode: '+223' },
  { name: 'Malta', code: 'MT', dialCode: '+356' },
  { name: 'Marshall Islands', code: 'MH', dialCode: '+692' },
  { name: 'Mauritania', code: 'MR', dialCode: '+222' },
  { name: 'Mauritius', code: 'MU', dialCode: '+230' },
  { name: 'Mexico', code: 'MX', dialCode: '+52' },
  { name: 'Micronesia', code: 'FM', dialCode: '+691' },
  { name: 'Moldova', code: 'MD', dialCode: '+373' },
  { name: 'Monaco', code: 'MC', dialCode: '+377' },
  { name: 'Mongolia', code: 'MN', dialCode: '+976' },
  { name: 'Montenegro', code: 'ME', dialCode: '+382' },
  { name: 'Morocco', code: 'MA', dialCode: '+212' },
  { name: 'Mozambique', code: 'MZ', dialCode: '+258' },
  { name: 'Myanmar (Burma)', code: 'MM', dialCode: '+95' },
  { name: 'Namibia', code: 'NA', dialCode: '+264' },
  { name: 'Nauru', code: 'NR', dialCode: '+674' },
  { name: 'Nepal', code: 'NP', dialCode: '+977' },
  { name: 'Netherlands', code: 'NL', dialCode: '+31' },
  { name: 'New Zealand', code: 'NZ', dialCode: '+64' },
  { name: 'Nicaragua', code: 'NI', dialCode: '+505' },
  { name: 'Niger', code: 'NE', dialCode: '+227' },
  { name: 'Nigeria', code: 'NG', dialCode: '+234' },
  { name: 'North Korea', code: 'KP', dialCode: '+850' },
  { name: 'North Macedonia', code: 'MK', dialCode: '+389' },
  { name: 'Norway', code: 'NO', dialCode: '+47' },
  { name: 'Oman', code: 'OM', dialCode: '+968' },
  { name: 'Pakistan', code: 'PK', dialCode: '+92' },
  { name: 'Palau', code: 'PW', dialCode: '+680' },
  { name: 'Palestine', code: 'PS', dialCode: '+970' },
  { name: 'Panama', code: 'PA', dialCode: '+507' },
  { name: 'Papua New Guinea', code: 'PG', dialCode: '+675' },
  { name: 'Paraguay', code: 'PY', dialCode: '+595' },
  { name: 'Peru', code: 'PE', dialCode: '+51' },
  { name: 'Philippines', code: 'PH', dialCode: '+63' },
  { name: 'Poland', code: 'PL', dialCode: '+48' },
  { name: 'Portugal', code: 'PT', dialCode: '+351' },
  { name: 'Qatar', code: 'QA', dialCode: '+974' },
  { name: 'Romania', code: 'RO', dialCode: '+40' },
  { name: 'Russia', code: 'RU', dialCode: '+7' },
  { name: 'Rwanda', code: 'RW', dialCode: '+250' },
  { name: 'Saint Kitts and Nevis', code: 'KN', dialCode: '+1-869' },
  { name: 'Saint Lucia', code: 'LC', dialCode: '+1-758' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC', dialCode: '+1-784' },
  { name: 'Samoa', code: 'WS', dialCode: '+685' },
  { name: 'San Marino', code: 'SM', dialCode: '+378' },
  { name: 'Sao Tome and Principe', code: 'ST', dialCode: '+239' },
  { name: 'Saudi Arabia', code: 'SA', dialCode: '+966' },
  { name: 'Senegal', code: 'SN', dialCode: '+221' },
  { name: 'Serbia', code: 'RS', dialCode: '+381' },
  { name: 'Seychelles', code: 'SC', dialCode: '+248' },
  { name: 'Sierra Leone', code: 'SL', dialCode: '+232' },
  { name: 'Singapore', code: 'SG', dialCode: '+65' },
  { name: 'Slovakia', code: 'SK', dialCode: '+421' },
  { name: 'Slovenia', code: 'SI', dialCode: '+386' },
  { name: 'Solomon Islands', code: 'SB', dialCode: '+677' },
  { name: 'Somalia', code: 'SO', dialCode: '+252' },
  { name: 'South Africa', code: 'ZA', dialCode: '+27' },
  { name: 'South Korea', code: 'KR', dialCode: '+82' },
  { name: 'South Sudan', code: 'SS', dialCode: '+211' },
  { name: 'Spain', code: 'ES', dialCode: '+34' },
  { name: 'Sri Lanka', code: 'LK', dialCode: '+94' },
  { name: 'Sudan', code: 'SD', dialCode: '+249' },
  { name: 'Suriname', code: 'SR', dialCode: '+597' },
  { name: 'Sweden', code: 'SE', dialCode: '+46' },
  { name: 'Switzerland', code: 'CH', dialCode: '+41' },
  { name: 'Syria', code: 'SY', dialCode: '+963' },
  { name: 'Taiwan', code: 'TW', dialCode: '+886' },
  { name: 'Tajikistan', code: 'TJ', dialCode: '+992' },
  { name: 'Tanzania', code: 'TZ', dialCode: '+255' },
  { name: 'Thailand', code: 'TH', dialCode: '+66' },
  { name: 'Togo', code: 'TG', dialCode: '+228' },
  { name: 'Tonga', code: 'TO', dialCode: '+676' },
  { name: 'Trinidad and Tobago', code: 'TT', dialCode: '+1-868' },
  { name: 'Tunisia', code: 'TN', dialCode: '+216' },
  { name: 'Turkey', code: 'TR', dialCode: '+90' },
  { name: 'Turkmenistan', code: 'TM', dialCode: '+993' },
  { name: 'Tuvalu', code: 'TV', dialCode: '+688' },
  { name: 'Uganda', code: 'UG', dialCode: '+256' },
  { name: 'Ukraine', code: 'UA', dialCode: '+380' },
  { name: 'United Arab Emirates', code: 'AE', dialCode: '+971' },
  { name: 'United Kingdom', code: 'GB', dialCode: '+44' },
  { name: 'United States', code: 'US', dialCode: '+1' },
  { name: 'Uruguay', code: 'UY', dialCode: '+598' },
  { name: 'Uzbekistan', code: 'UZ', dialCode: '+998' },
  { name: 'Vanuatu', code: 'VU', dialCode: '+678' },
  { name: 'Vatican City', code: 'VA', dialCode: '+39' },
  { name: 'Venezuela', code: 'VE', dialCode: '+58' },
  { name: 'Vietnam', code: 'VN', dialCode: '+84' },
  { name: 'Yemen', code: 'YE', dialCode: '+967' },
  { name: 'Zambia', code: 'ZM', dialCode: '+260' },
  { name: 'Zimbabwe', code: 'ZW', dialCode: '+263' }
];

// Dropdown options for Countries
export const COUNTRIES_LIST = ALL_COUNTRIES_DATA.map((c) => ({
  value: c.name,
  label: c.name
}));

// Lookup dial code given a country name (case-insensitive fuzzy match fallback)
export const getDialCodeForCountry = (countryName) => {
  if (!countryName) return null;
  const normalized = String(countryName).trim().toLowerCase();
  const found = ALL_COUNTRIES_DATA.find(
    (c) => c.name.toLowerCase() === normalized || c.code.toLowerCase() === normalized
  );
  return found ? found.dialCode : null;
};

// Full list of country dial codes
export const PHONE_CODES_LIST = ALL_COUNTRIES_DATA.map((c) => ({
  value: c.dialCode,
  label: `${c.dialCode} (${c.name})`,
  country: c.name
})).sort((a, b) => a.country.localeCompare(b.country));

// ─── 2. Comprehensive Global Time Zones ──────────────────────────────────────
export const TIMEZONES_LIST = [
  // ─── Popular / Standard Time Zones with Common Abbreviations ───────────────
  { value: 'EST',       label: 'EST — Eastern Time (UTC-5) • New York, Miami, Toronto, Atlanta' },
  { value: 'CST',       label: 'CST — Central Time (UTC-6) • Chicago, Dallas, Houston, Mexico City' },
  { value: 'MST',       label: 'MST — Mountain Time (UTC-7) • Denver, Phoenix, Salt Lake, Calgary' },
  { value: 'PST',       label: 'PST — Pacific Time (UTC-8) • Los Angeles, San Francisco, Seattle, Vancouver' },
  { value: 'AKST',      label: 'AKST — Alaska Time (UTC-9) • Anchorage, Fairbanks' },
  { value: 'HST',       label: 'HST — Hawaii Standard Time (UTC-10) • Honolulu' },
  { value: 'IST',       label: 'IST — India Standard Time (UTC+5:30) • New Delhi, Mumbai, Bengaluru, Chennai' },
  { value: 'GMT',       label: 'GMT / UTC — Greenwich Mean Time (UTC+0) • London, Dublin, Lisbon' },
  { value: 'CET',       label: 'CET — Central European Time (UTC+1) • Paris, Berlin, Rome, Madrid' },
  { value: 'EET',       label: 'EET — Eastern European Time (UTC+2) • Cairo, Athens, Johannesburg' },
  { value: 'MSK',       label: 'MSK — Moscow Time (UTC+3) • Moscow, Nairobi, Riyadh, Istanbul' },
  { value: 'GST',       label: 'GST — Gulf Standard Time (UTC+4) • Dubai, Abu Dhabi, Muscat' },
  { value: 'PKT',       label: 'PKT — Pakistan Standard Time (UTC+5) • Karachi, Islamabad' },
  { value: 'BST',       label: 'BST — Bangladesh Standard Time (UTC+6) • Dhaka, Almaty' },
  { value: 'ICT',       label: 'ICT — Indochina Time (UTC+7) • Bangkok, Jakarta, Hanoi' },
  { value: 'SGT',       label: 'SGT / HKT — Singapore & Hong Kong (UTC+8) • Singapore, Beijing, Perth' },
  { value: 'JST',       label: 'JST / KST — Japan & Korea (UTC+9) • Tokyo, Seoul' },
  { value: 'ACST',      label: 'ACST — Australian Central (UTC+9:30) • Adelaide, Darwin' },
  { value: 'AEST',      label: 'AEST — Australian Eastern (UTC+10) • Sydney, Melbourne, Brisbane' },
  { value: 'NZST',      label: 'NZST — New Zealand Time (UTC+12) • Auckland, Wellington' },

  // ─── All World UTC Offsets with Abbreviations & Regions ─────────────────────
  { value: 'UTC-12:00', label: 'UTC-12:00 (IDLW — International Date Line West)' },
  { value: 'UTC-11:00', label: 'UTC-11:00 (SST — Samoa, Niue, Pago Pago)' },
  { value: 'UTC-10:00', label: 'UTC-10:00 (HST — Hawaii, Honolulu, Tahiti)' },
  { value: 'UTC-09:30', label: 'UTC-09:30 (MIT — Marquesas Islands)' },
  { value: 'UTC-09:00', label: 'UTC-09:00 (AKST — Alaska, Anchorage)' },
  { value: 'UTC-08:00', label: 'UTC-08:00 (PST — Pacific Time / Los Angeles, Vancouver)' },
  { value: 'UTC-07:00', label: 'UTC-07:00 (MST — Mountain Time / Denver, Phoenix, Calgary)' },
  { value: 'UTC-06:00', label: 'UTC-06:00 (CST — Central Time / Chicago, Dallas, Mexico City)' },
  { value: 'UTC-05:00', label: 'UTC-05:00 (EST — Eastern Time / New York, Toronto, Miami)' },
  { value: 'UTC-04:00', label: 'UTC-04:00 (AST — Atlantic Time / Halifax, Santiago, Caracas)' },
  { value: 'UTC-03:30', label: 'UTC-03:30 (NST — Newfoundland, St. Johns)' },
  { value: 'UTC-03:00', label: 'UTC-03:00 (BRT / ART — Buenos Aires, Sao Paulo, Rio)' },
  { value: 'UTC-02:00', label: 'UTC-02:00 (GST — South Georgia, Mid-Atlantic)' },
  { value: 'UTC-01:00', label: 'UTC-01:00 (AZOT / CVT — Azores, Cape Verde)' },
  { value: 'UTC+0:00',  label: 'UTC+0:00 (GMT / WET — London, Dublin, Lisbon, Accra)' },
  { value: 'UTC+1:00',  label: 'UTC+1:00 (CET / WAT — Paris, Berlin, Rome, Lagos)' },
  { value: 'UTC+2:00',  label: 'UTC+2:00 (EET / CAT — Cairo, Athens, Johannesburg, Jerusalem)' },
  { value: 'UTC+3:00',  label: 'UTC+3:00 (MSK / EAT — Moscow, Nairobi, Riyadh, Istanbul)' },
  { value: 'UTC+3:30',  label: 'UTC+3:30 (IRST — Tehran, Iran)' },
  { value: 'UTC+4:00',  label: 'UTC+4:00 (GST — Dubai, Abu Dhabi, Baku, Tbilisi)' },
  { value: 'UTC+4:30',  label: 'UTC+4:30 (AFT — Kabul, Afghanistan)' },
  { value: 'UTC+5:00',  label: 'UTC+5:00 (PKT — Karachi, Islamabad, Tashkent)' },
  { value: 'UTC+5:30',  label: 'UTC+5:30 (IST — India Standard Time / New Delhi, Mumbai)' },
  { value: 'UTC+5:45',  label: 'UTC+5:45 (NPT — Kathmandu, Nepal)' },
  { value: 'UTC+6:00',  label: 'UTC+6:00 (BST — Dhaka, Almaty, Omsk)' },
  { value: 'UTC+6:30',  label: 'UTC+6:30 (MMT — Yangon, Cocos, Myanmar)' },
  { value: 'UTC+7:00',  label: 'UTC+7:00 (ICT / WIB — Bangkok, Jakarta, Hanoi)' },
  { value: 'UTC+8:00',  label: 'UTC+8:00 (SGT / HKT / CST — Singapore, Beijing, Perth, Manila)' },
  { value: 'UTC+8:45',  label: 'UTC+8:45 (ACWST — Eucla, Western Australia)' },
  { value: 'UTC+9:00',  label: 'UTC+9:00 (JST / KST — Tokyo, Seoul, Osaka)' },
  { value: 'UTC+9:30',  label: 'UTC+9:30 (ACST — Adelaide, Darwin)' },
  { value: 'UTC+10:00', label: 'UTC+10:00 (AEST — Sydney, Melbourne, Brisbane, Guam)' },
  { value: 'UTC+10:30', label: 'UTC+10:30 (LHST — Lord Howe Island)' },
  { value: 'UTC+11:00', label: 'UTC+11:00 (SBT — Solomon Islands, Vanuatu, New Caledonia)' },
  { value: 'UTC+12:00', label: 'UTC+12:00 (NZST — Auckland, Wellington, Fiji)' },
  { value: 'UTC+12:45', label: 'UTC+12:45 (CHAST — Chatham Islands)' },
  { value: 'UTC+13:00', label: 'UTC+13:00 (TOT — Tonga, Samoa, Tokelau)' },
  { value: 'UTC+14:00', label: 'UTC+14:00 (LINT — Line Islands, Kiritimati)' }
];

// ─── 3. Comprehensive Global Languages ───────────────────────────────────────
export const LANGUAGES_LIST = [
  { value: 'English', label: 'English' },
  { value: 'Telugu', label: 'Telugu (తెలుగు)' },
  { value: 'Hindi', label: 'Hindi (हिन्दी)' },
  { value: 'Tamil', label: 'Tamil (தமிழ்)' },
  { value: 'Malayalam', label: 'Malayalam (മലയാളം)' },
  { value: 'Kannada', label: 'Kannada (ಕನ್ನಡ)' },
  { value: 'Marathi', label: 'Marathi (मराठी)' },
  { value: 'Bengali', label: 'Bengali (বাংলা)' },
  { value: 'Gujarati', label: 'Gujarati (ગુજરાતી)' },
  { value: 'Punjabi', label: 'Punjabi (ਪੰਜਾਬੀ)' },
  { value: 'Odia', label: 'Odia (ଓଡ଼ିଆ)' },
  { value: 'Urdu', label: 'Urdu (اردو)' },
  { value: 'Assamese', label: 'Assamese (অসমীয়া)' },
  { value: 'Spanish', label: 'Spanish (Español)' },
  { value: 'Portuguese', label: 'Portuguese (Português)' },
  { value: 'French', label: 'French (Français)' },
  { value: 'German', label: 'German (Deutsch)' },
  { value: 'Italian', label: 'Italian (Italiano)' },
  { value: 'Dutch', label: 'Dutch (Nederlands)' },
  { value: 'Russian', label: 'Russian (Русский)' },
  { value: 'Ukrainian', label: 'Ukrainian (Українська)' },
  { value: 'Chinese (Simplified)', label: 'Chinese Simplified (简体中文)' },
  { value: 'Chinese (Traditional)', label: 'Chinese Traditional (繁體中文)' },
  { value: 'Korean', label: 'Korean (한국어)' },
  { value: 'Japanese', label: 'Japanese (日本語)' },
  { value: 'Tagalog', label: 'Tagalog / Filipino' },
  { value: 'Indonesian', label: 'Indonesian (Bahasa Indonesia)' },
  { value: 'Malay', label: 'Malay (Bahasa Melayu)' },
  { value: 'Vietnamese', label: 'Vietnamese (Tiếng Việt)' },
  { value: 'Thai', label: 'Thai (ภาษาไทย)' },
  { value: 'Burmese', label: 'Burmese (မြန်မာ)' },
  { value: 'Nepali', label: 'Nepali (नेपाली)' },
  { value: 'Sinhala', label: 'Sinhala (සිංහල)' },
  { value: 'Arabic', label: 'Arabic (العربية)' },
  { value: 'Hebrew', label: 'Hebrew (עברית)' },
  { value: 'Swahili', label: 'Swahili (Kiswahili)' },
  { value: 'Amharic', label: 'Amharic (አማርኛ)' },
  { value: 'Yoruba', label: 'Yoruba' },
  { value: 'Igbo', label: 'Igbo' },
  { value: 'Hausa', label: 'Hausa' },
  { value: 'Zulu', label: 'Zulu (isiZulu)' },
  { value: 'Afrikaans', label: 'Afrikaans' },
  { value: 'Greek', label: 'Greek (Ελληνικά)' },
  { value: 'Turkish', label: 'Turkish (Türkçe)' },
  { value: 'Polish', label: 'Polish (Polski)' },
  { value: 'Romanian', label: 'Romanian (Română)' },
  { value: 'Czech', label: 'Czech (Čeština)' },
  { value: 'Hungarian', label: 'Hungarian (Magyar)' },
  { value: 'Swedish', label: 'Swedish (Svenska)' },
  { value: 'Norwegian', label: 'Norwegian (Norsk)' },
  { value: 'Danish', label: 'Danish (Dansk)' },
  { value: 'Finnish', label: 'Finnish (Suomi)' },
  { value: 'Other', label: 'Other Language' }
];

// ─── 4. Bible Versions by Language ───────────────────────────────────────────
export const BIBLE_VERSIONS_BY_LANGUAGE = {
  English: [
    { value: 'KJV',  label: 'King James Version (KJV)' },
    { value: 'NKJV', label: 'New King James Version (NKJV)' },
    { value: 'NIV',  label: 'New International Version (NIV)' },
    { value: 'ESV',  label: 'English Standard Version (ESV)' },
    { value: 'NLT',  label: 'New Living Translation (NLT)' },
    { value: 'NASB', label: 'New American Standard Bible (NASB)' },
    { value: 'CSB',  label: 'Christian Standard Bible (CSB)' },
    { value: 'AMP',  label: 'Amplified Bible (AMP)' },
    { value: 'MSG',  label: 'The Message (MSG)' },
    { value: 'ASV',  label: 'American Standard Version (ASV)' },
    { value: 'RSV',  label: 'Revised Standard Version (RSV)' },
    { value: 'NRSV', label: 'New Revised Standard Version (NRSV)' },
    { value: 'CEV',  label: 'Contemporary English Version (CEV)' },
    { value: 'GNT',  label: 'Good News Translation (GNT)' }
  ],
  Telugu: [
    { value: 'BSI Telugu', label: 'పరిశుద్ధ గ్రంథము (BSI - Bible Society of India)' },
    { value: 'IRV Telugu',  label: 'ఇండియన్ రివైజ్డ్ వెర్షన్ (IRV Telugu)' },
    { value: 'ERV Telugu',  label: 'ఈజీ-టు-రీడ్ వెర్షన్ (ERV Telugu Easy-to-Read)' },
    { value: 'TCV Telugu',  label: 'తెలుగు కాంటెంపరరీ వెర్షన్ (TCV)' },
    { value: 'BI Telugu',   label: 'పరిశుద్ధ బైబిల్ (Bibles India)' }
  ],
  Hindi: [
    { value: 'BSI Hindi',  label: 'पवित्र बाइबिल (BSI - Bible Society of India)' },
    { value: 'IRV Hindi',  label: 'इंडियन रिवाइज्ड वर्शन (IRV Hindi)' },
    { value: 'ERV Hindi',  label: 'सरल हिन्दी बाइबिल (ERV Easy-to-Read)' },
    { value: 'HHBD Hindi', label: 'धर्मशास्त्र पवित्र बाइबिल (HHBD)' }
  ],
  Tamil: [
    { value: 'BSI Tamil OV', label: 'பரிசுத்த வேதாகமம் (BSI Old Version)' },
    { value: 'IRV Tamil',    label: 'இந்தியன் ரிவைஸ்டு வெர்ஷன் (IRV Tamil)' },
    { value: 'ERV Tamil',    label: 'எளிய தமிழ் வேதாகமம் (ERV Easy-to-Read)' },
    { value: 'RCV Tamil',    label: 'திருத்திய பொது மொழிபெயர்ப்பு (RCV)' }
  ],
  Malayalam: [
    { value: 'BSI Malayalam', label: 'സത്യവേദപുസ്തകം (BSI Malayalam)' },
    { value: 'IRV Malayalam', label: 'ഇന്ത്യൻ റിവൈസ്ഡ് വേർഷൻ (IRV Malayalam)' },
    { value: 'ERV Malayalam', label: 'എളുപ്പത്തിൽ വായിക്കാവുന്ന ബൈബിൾ (ERV)' },
    { value: 'POC Malayalam', label: 'പീ.ഓ.സീ ബൈബിൾ (POC Bible)' }
  ],
  Kannada: [
    { value: 'BSI Kannada', label: 'ಸತ್ಯವೇದವು (BSI Kannada)' },
    { value: 'IRV Kannada', label: 'ಇಂಡಿಯನ್ ರಿವೈಸ್ಡ್ ಆವೃತ್ತಿ (IRV Kannada)' },
    { value: 'ERV Kannada', label: 'ಸುಲಭ ಓದುವ ಕನ್ನಡ ಬೈಬಲ್ (ERV)' }
  ],
  Marathi: [
    { value: 'BSI Marathi', label: 'पवित्र शास्त्र (BSI Marathi)' },
    { value: 'IRV Marathi', label: 'इंडियन रिव्हाइज्ड व्हर्जन (IRV Marathi)' },
    { value: 'ERV Marathi', label: 'सोपे मराठी बायबल (ERV Marathi)' }
  ],
  Bengali: [
    { value: 'BSI Bengali', label: 'পবিত্র বাইবেল (BSI Bengali)' },
    { value: 'IRV Bengali', label: 'ইন্ডিয়ান রিভাইজড ভার্সন (IRV Bengali)' },
    { value: 'ERV Bengali', label: 'সহজ পাঠ্য বাইবেল (ERV Bengali)' }
  ],
  Gujarati: [
    { value: 'BSI Gujarati', label: 'પવિત્ર બાઇબલ (BSI Gujarati)' },
    { value: 'IRV Gujarati', label: 'ઇન્ડિયન રિવાઇઝ્ડ વર્ઝન (IRV Gujarati)' }
  ],
  Punjabi: [
    { value: 'BSI Punjabi', label: 'ਪਵਿੱਤਰ ਬਾਈਬਲ (BSI Punjabi)' },
    { value: 'IRV Punjabi', label: 'ਇੰਡੀਅਨ ਰਿਵਾਇਜ਼ਡ ਵਰਜ਼ਨ (IRV Punjabi)' }
  ],
  Odia: [
    { value: 'BSI Odia', label: 'ପବିତ୍ର ବାଇବଲ (BSI Odia)' },
    { value: 'IRV Odia', label: 'ଇଣ୍ଡିଆନ ରିଭାଇଜ୍ଡ ଭର୍ସନ (IRV Odia)' }
  ],
  Urdu: [
    { value: 'BSI Urdu', label: 'مقدس بائبل (BSI Urdu Geo)' },
    { value: 'IRV Urdu', label: 'انڈین ریوائزڈ ورژن (IRV Urdu)' }
  ],
  Assamese: [
    { value: 'BSI Assamese', label: 'পবিত্ৰ বাইবেল (BSI Assamese)' },
    { value: 'IRV Assamese', label: 'ইণ্ডিয়ান ৰিভাইজড ভার্সন (IRV Assamese)' }
  ],
  Spanish: [
    { value: 'RVR1960', label: 'Reina-Valera 1960 (RVR1960)' },
    { value: 'NVI',     label: 'Nueva Versión Internacional (NVI)' },
    { value: 'DHH',     label: 'Dios Habla Hoy (DHH)' },
    { value: 'LBLA',    label: 'La Biblia de las Américas (LBLA)' },
    { value: 'NTV',     label: 'Nueva Traducción Viviente (NTV)' },
    { value: 'TLA',     label: 'Traducción en Lenguaje Actual (TLA)' }
  ],
  Portuguese: [
    { value: 'ARC',  label: 'Almeida Revista e Corrigida (ARC)' },
    { value: 'ARA',  label: 'Almeida Revista e Atualizada (ARA)' },
    { value: 'NVI',  label: 'Nova Versão Internacional (NVI)' },
    { value: 'NTLH', label: 'Nova Tradução na Linguagem de Hoje (NTLH)' },
    { value: 'NAA',  label: 'Nova Almeida Atualizada (NAA)' }
  ],
  French: [
    { value: 'LSG', label: 'Louis Segond 1910 (LSG)' },
    { value: 'BDS', label: 'La Bible du Semeur (BDS)' },
    { value: 'NFC', label: 'Nouvelle Français Courant (NFC)' },
    { value: 'PDV', label: 'Parole de Vie (PDV)' }
  ],
  German: [
    { value: 'LUT',     label: 'Lutherbibel 2017 (LUT)' },
    { value: 'SCH2000', label: 'Schlachter 2000 (SCH2000)' },
    { value: 'ELB',     label: 'Elberfelder Bibel (ELB)' },
    { value: 'HFA',     label: 'Hoffnung für Alle (HFA)' }
  ],
  'Chinese (Simplified)': [
    { value: 'CUVS', label: 'Chinese Union Version Simplified (和合本简体 - CUVS)' },
    { value: 'CNVS', label: 'New Chinese Version Simplified (新译本简体 - CNVS)' },
    { value: 'CCB',  label: 'Contemporary Chinese Bible (当代圣经 - CCB)' }
  ],
  'Chinese (Traditional)': [
    { value: 'CUV', label: 'Chinese Union Version Traditional (和合本繁體 - CUV)' },
    { value: 'CNV', label: 'New Chinese Version Traditional (新譯本繁體 - CNV)' }
  ],
  Korean: [
    { value: 'NKRV', label: 'New Korean Revised Version (개역개정 - NKRV)' },
    { value: 'KRV',  label: 'Korean Revised Version (개역한글 - KRV)' },
    { value: 'KLB',  label: 'Korean Living Bible (현대인의 성경 - KLB)' }
  ],
  Japanese: [
    { value: 'SHIN',       label: 'Shinkaiyaku 2017 (新改訳2017)' },
    { value: 'SHINKYODO',  label: 'Shin Kyodo Yaku (新共同訳)' },
    { value: 'KOUGO',      label: 'Kougo-yaku (口語訳)' }
  ],
  Tagalog: [
    { value: 'MBBTAG', label: 'Magandang Balita Biblia (MBBTAG)' },
    { value: 'ADB',    label: 'Ang Dating Biblia 1905 (ADB)' },
    { value: 'SND',    label: 'Salita ng Diyos (SND)' }
  ],
  Indonesian: [
    { value: 'TB',  label: 'Terjemahan Baru (TB - LAI)' },
    { value: 'TB2', label: 'Terjemahan Baru Edisi 2 (TB2)' },
    { value: 'BIS', label: 'Bahasa Indonesia Masa Kini (BIS)' },
    { value: 'TSI', label: 'Terjemahan Sederhana Indonesia (TSI)' }
  ],
  Swahili: [
    { value: 'SUV', label: 'Swahili Union Version (SUV)' },
    { value: 'NEN', label: 'Neno: Bibilia Takatifu (NEN)' },
    { value: 'BHN', label: 'Biblia Habari Njema (BHN)' }
  ],
  Arabic: [
    { value: 'SVD', label: 'Smith & Van Dyke Arabic Bible (فانديك)' },
    { value: 'NAV', label: 'Ketab El Hayat (كتاب الحياة)' },
    { value: 'ERV', label: 'Arabic Easy-to-Read Version (النسخة المبسطة)' }
  ],
  Russian: [
    { value: 'SYNOD', label: 'Synodal Translation (Синодальный перевод)' },
    { value: 'NRT',   label: 'New Russian Translation (Новый русский перевод)' }
  ],
  Italian: [
    { value: 'NR06', label: 'Nuova Riveduta 2006 (NR06)' },
    { value: 'CEI',  label: 'Conferenza Episcopale Italiana (CEI)' }
  ],
  Dutch: [
    { value: 'NBG', label: 'NBG-vertaling 1951 (NBG)' },
    { value: 'HTB', label: 'Het Boek (HTB)' }
  ],
  Vietnamese: [
    { value: 'BPT',  label: 'Bản Phổ Thông (BPT)' },
    { value: 'VIET', label: 'Bản Dịch 1926 Truyền Thống (VIET)' }
  ]
};

// Generic fallback versions for languages without specific list
const DEFAULT_BIBLE_VERSIONS = [
  { value: 'Standard', label: 'Standard Holy Bible Version' },
  { value: 'Common',   label: 'Common Language Version' },
  { value: 'KJV',      label: 'King James Version (KJV)' },
  { value: 'Study',    label: 'Study Bible Edition' }
];

/**
 * Returns available Bible versions for the selected language.
 * Ensures the currently selected value is included if not in standard list.
 */
export const getBibleVersionsForLanguage = (language, currentVersion) => {
  if (!language) return BIBLE_VERSIONS_BY_LANGUAGE.English;

  // Match language
  const key = Object.keys(BIBLE_VERSIONS_BY_LANGUAGE).find(
    (k) => k.toLowerCase() === String(language).toLowerCase() ||
           String(language).toLowerCase().includes(k.toLowerCase())
  );

  const versions = key ? [...BIBLE_VERSIONS_BY_LANGUAGE[key]] : [...DEFAULT_BIBLE_VERSIONS];

  // If currentVersion exists but not in the matched list, prepend/keep it so selection doesn't break
  if (currentVersion && !versions.some((v) => v.value === currentVersion)) {
    versions.unshift({
      value: currentVersion,
      label: `${currentVersion} (Current Version)`
    });
  }

  return versions;
};
